import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry, faGears, faBuilding, faMicrochip, faBolt, faCogs } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../i18n/LanguageContext';
import './ClientLogos.css';

// Placeholder logos textuels — remplacez par de vraies images dans /public/images/clients/
const clients = [
  { name: 'KUBITECH', icon: faIndustry, sector: 'Industrie' },
  { name: 'P-S-M', icon: faGears, sector: 'Mécanique' },
  { name: 'Industrial Co.', icon: faBuilding, sector: 'Production' },
  { name: 'TechCraft', icon: faMicrochip, sector: 'Électronique' },
  { name: 'Volt Systems', icon: faBolt, sector: 'Énergie' },
  { name: 'Mécanique+', icon: faCogs, sector: 'Usinage' }
];

const ClientLogos = () => {
  const { t } = useLanguage();
  return (
    <section className="client-logos">
      <div className="container">
        <p className="client-logos__label">{t('clientLogos.title')}</p>
        <div className="client-logos__marquee">
          <div className="client-logos__track">
            {[...clients, ...clients].map((c, i) => (
              <div className="client-logo" key={i} aria-label={c.name}>
                <FontAwesomeIcon icon={c.icon} />
                <span className="client-logo__name">{c.name}</span>
                <span className="client-logo__sector">{c.sector}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
